import React, { FC, useMemo } from 'react';

import { SliderProps } from 'rc-slider';

import { MAX_ROI, MIN_ROI } from '../../../../../utils';
import { RangeSlider } from '../../../../common';
import { RangeSliderProps } from '../../../../common/selects/RangeSlider/RangeSlider';

import './YearProfitSlider.scoped.scss';

interface Props {
  currentValue: Array<number | undefined | null>;
}

const RoiSlider: FC<SliderProps & RangeSliderProps & Props> = ({
  handleChange,
  currentValue,
  ...props
}) => {
  const value = useMemo((): Array<number> => {
    return [
      currentValue[0] === 0 || currentValue[0] === undefined || currentValue[0] === null
        ? MIN_ROI
        : currentValue[0],
      currentValue[1] === 0 || currentValue[1] === undefined || currentValue[1] === null
        ? MAX_ROI
        : currentValue[1],
    ];
  }, [currentValue]);

  return (
    <div>
      <RangeSlider
        {...props}
        min={MIN_ROI}
        max={MAX_ROI}
        defaultValue={[MIN_ROI, MAX_ROI]}
        pushable={true}
        handleChange={handleChange}
        value={value}
      />
      <div className="slider-labels">
        <div>{currentValue[0] ? currentValue[0] + '%' : `${MIN_ROI}%`}</div>
        <div>
          {currentValue[1] && currentValue[1] < MAX_ROI ? currentValue[1] + '%' : 'Нет лимита'}
        </div>
      </div>
    </div>
  );
};

export default RoiSlider;
